import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    lastAccessedActivity:{}
};

export const courseActivitySlice = createSlice({
    name:"courseActivity",
    initialState,
    reducers:{
        updateLastAccessedActivity: (state, actions) => {
                
        },
    },
});

export const { updateLastAccessedActivity } = courseActivitySlice.actions;

export default courseActivitySlice.reducer;